import EventEmitter from 'events';

class Store extends EventEmitter {

    emit(event, args) {
        super.emit(event, args);
    }

    addEventListener(event, callback) {
        this.on(event, callback);
    }

    removeEventListener(event, callback) {
        this.removeListener(event, callback);
    }
}

Store.dispatchToken = null;

export default Store;